import {
    getStoreType,
} from 'typed-vuex';
import { DeployParam, DeployParamKind, DeployParamValue } from '@redviking/argonaut-util/src/mes/deployParam.zod';

/**
 * when deployment params are initialized in a deployment, this function determines their initial values.
 */
export function getInitialDeployParamValue (deployParam: DeployParam): DeployParamValue {
    if (deployParam.deployParamKind === DeployParamKind.localVarValue) {
        if (deployParam.type === 'str') {
            return {
                kind: DeployParamKind.localVarValue,
                val: deployParam.defaultValue,
                schemaVersion: 4,
                enabled: true,
            };
        } else if (deployParam.type === 'num') {
            return {
                kind: DeployParamKind.localVarValue,
                val: deployParam.defaultValue,
                schemaVersion: 4,
                enabled: true,
            };
        } else if (deployParam.type === 'bool') {
            return {
                kind: DeployParamKind.localVarValue,
                val: deployParam.defaultValue,
                schemaVersion: 4,
                enabled: true,
            };
        } else if (deployParam.type === 'empty') {
            return {
                kind: DeployParamKind.localVarValue,
                val: null,
                schemaVersion: 4,
                enabled: true,
            };
        } else {
            const unknownType: never = deployParam;
            throw new Error(`Unknown deploy param type: ${unknownType}`);
        }
    } else if (deployParam.deployParamKind === DeployParamKind.location) {
        return {
            kind: DeployParamKind.location,
            val: '',
            schemaVersion: 4,
        };
    } else if (deployParam.deployParamKind === DeployParamKind.asset) {
        return {
            kind: DeployParamKind.asset,
            val: '',
            schemaVersion: 4,
        };
    } else if (deployParam.deployParamKind === DeployParamKind.sparkplugNodeCfg) {
        return {
            kind: DeployParamKind.sparkplugNodeCfg,
            val: {
                    deviceId: '',
                    groupId: '',
                    nodeId: '',
                    version: '',
                },
            schemaVersion: 4,
        };
    } else {
        // @ts-expect-error - ensures cases are implemented
        const unknownKind: string = deployParam.deployParamKind;
        throw new Error(`Unknown deploy param kind: ${unknownKind}`);
    }
}

export const appConfigStore = {
    namespaced: true,
    state: {},
};

const storeType = getStoreType(appConfigStore);
export type AppConfigStore = typeof storeType;

export default appConfigStore;
